module.exports = __webpack_public_path__ + "static/media/sphere.bdc9926e.png";